var _messages;

import { defineMessages } from "react-intl";
import "./MessageDescriptor";

var messages = (_messages = {}, _messages["ga:users"] = {
  id: "ga.metric.users",
  defaultMessage: "Brukere",
  description: "ga:users"
}, _messages["ga:newUsers"] = {
  id: "ga.metric.newUsers",
  defaultMessage: "Nye brukere",
  description: "ga:newUsers"
}, _messages["ga:sessions"] = {
  id: "ga.metric.sessions",
  defaultMessage: "Besøk",
  description: "ga:sessions"
}, _messages["ga:percentNewSessions"] = {
  id: "ga.metric.percentNewSessions",
  defaultMessage: "Nye besøk",
  description: "ga:percentNewSessions"
}, _messages["ga:bounces"] = {
  id: "ga.metric.bounces",
  defaultMessage: "Flukt",
  description: "ga:bounces"
}, _messages["ga:bounceRate"] = {
  id: "ga.metric.bounceRate",
  defaultMessage: "Fluktfrekvens",
  description: "ga:bounceRate"
}, _messages["ga:sessionDuration"] = {
  id: "ga.metric.sessionDuration",
  defaultMessage: "Tid per besøk",
  description: "ga:sessionDuration"
}, _messages["ga:avgSessionDuration"] = {
  id: "ga.metric.avgSessionDuration",
  defaultMessage: "Tid/besøk",
  description: "ga:avgSessionDuration"
}, _messages["ga:uniquePageviews"] = {
  id: "ga.metric.uniquePageviews",
  defaultMessage: "Unike sidevisninger",
  description: "ga:uniquePageviews"
}, _messages["ga:pageviews"] = {
  id: "ga.metric.pageviews",
  defaultMessage: "Sidevisninger",
  description: "ga:pageviews"
}, _messages["ga:pageviewsPerSession"] = {
  id: "ga.metric.pageviewsPerSession",
  defaultMessage: "Sider/besøk",
  description: "ga:pageviewsPerSession"
}, _messages["ga:timeOnPage"] = {
  id: "ga.metric.timeOnPage",
  defaultMessage: "Tid per side",
  description: "ga:timeOnPage"
}, _messages["ga:avgTimeOnPage"] = {
  id: "ga.metric.avgTimeOnPage",
  defaultMessage: "Tid/side",
  description: "ga:avgTimeOnPage"
}, _messages["ga:medium:organic"] = {
  id: "ga.medium.organic",
  defaultMessage: "Organisk",
  description: ""
}, _messages["ga:medium:referral"] = {
  id: "ga.medium.referral",
  defaultMessage: "Henvisning",
  description: ""
}, _messages["ga:medium:(none)"] = {
  id: "ga.medium.none",
  defaultMessage: "Ukjent",
  description: ""
}, _messages);

var definedMessages = defineMessages(messages);

export default definedMessages;